import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { VendorSubscriptionResponse } from '@lov/shared';

// Query key factory following planKeys pattern
export const subscriptionKeys = {
  all: ['vendor-subscription'] as const,
  current: () => [...subscriptionKeys.all, 'current'] as const,
  plans: () => [...subscriptionKeys.all, 'available-plans'] as const,
  history: () => [...subscriptionKeys.all, 'billing-history'] as const,
};

export function useVendorSubscription(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: subscriptionKeys.current(),
    queryFn: async () => {
      return await api.get<VendorSubscriptionResponse>('/vendor/subscription');
    },
    enabled: options?.enabled ?? true,
  });
}
